import React from 'react';
import { useTranslation } from 'react-i18next';
import TierHexagonIcon from '@wix/da-ds/pkg/Icons/32x32/TierHexagon';
import s from './SubscribersOnly.scss';
var SubscribersOnly = function () {
    var t = useTranslation().t;
    return (React.createElement("div", { className: s['root'] },
        React.createElement(TierHexagonIcon, { className: s['icon'] }),
        React.createElement("span", { className: s['text'] }, t('memberSubscriptions.subscribersOnly'))));
};
SubscribersOnly.displayName = 'SubscribersOnly';
export default SubscribersOnly;
//# sourceMappingURL=SubscribersOnly.js.map